import { useTranslation } from "react-i18next";
import { DocumentVersionStatus } from "~/config/types";
import { FieldStatus } from "~/molecules/FieldStatus";

interface DocumentVersionStatusBadgeProps {
  status?: DocumentVersionStatus;
  isWorkflowOngoing?: boolean;
}

const NotStartedBadge = () => {
  const { t } = useTranslation();

  return (
    <div className="w-min rounded-2xl bg-amber-100 px-2 py-1 text-xs font-medium whitespace-nowrap text-amber-700">
      {t(($) => $.commons.workflow.notStarted)}
    </div>
  );
};

export const DocumentVersionStatusBadge = ({
  status,
  isWorkflowOngoing,
}: DocumentVersionStatusBadgeProps) => {
  if (!status) {
    return null;
  }

  const showNotStartedBadge =
    status === DocumentVersionStatus.draft && isWorkflowOngoing === false;

  return (
    <div className="flex items-center gap-1">
      <FieldStatus dvStatus={status} />
      {showNotStartedBadge && <NotStartedBadge />}
    </div>
  );
};
